import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import NavBar from "../../components/NavBar";
import Footer from "../../components/landing/Footer";
import AISearchSection from "../../components/landing/aisearch/AISearchSection";
import NetworkIntroSection from "../../components/landing/aisearch/NetworkIntroSection";

const AISearchPage = () => {
  useEffect(() => {
    document.title = "Majura - AI Search";
  }, []);

  return (
    <div style={{ width: "100vw", height: "100%" }}>
      <Grid container spacing={0} style={{ width: "100%", height: "100%" }}>
        <Grid size={{ xs: 12 }}>
          <NavBar
            isMain={false}
            isSticky={true}
            bgColor={"transparent"}
            isNotification={false}
            showLogin={true}
          />

          <main>
            <Stack direction={"column"} style={{ width: "100%" }}>
              <NetworkIntroSection />
              <AISearchSection />
            </Stack>
          </main>

          <footer>
            <Footer />
          </footer>
        </Grid>
      </Grid>
    </div>
  );
};

export default AISearchPage;
